import Router from 'next/router';
import {
  CUSTOMIZATION_MODES,
  CUSTOMIZATION_NAMES,
  CUSTOMIZATION_ROUTE,
  CUSTOMIZATION_ROUTE_PREFIX, CUSTOMIZATION_STEPS,
} from '@/constants/customization';

export const customizationSetPrevStep = (id, step, options) => {
  const { continueStep } = options;

  if (continueStep) {
    customizationSwitchStep(id, continueStep, {
      ...options,
      mode: undefined,
      continueStep: undefined
    });
  } else {
    customizationSwitchStep(id, customizationGetPrevStep(step).url, {
      ...options,
      mode: undefined
    });
  }
};

export const customizationSetNextStep = (id, step, options) => {
  const { continueStep } = options;

  if (continueStep) {
    customizationSwitchStep(id, continueStep, {
      ...options,
      mode: undefined,
      continueStep: undefined
    });
  } else {
    customizationSwitchStep(id, customizationGetNextStep(step).url, {
      ...options,
      mode: undefined
    });
  }
};

export const customizationSwitchMode = (id, url, options, mode) => {
  customizationSwitchStep(id, url, {
    ...options,
    mode,
    shallow: true
  });
};

export const customizationSwitchStep = (id, step = CUSTOMIZATION_NAMES.TEXT, options) => {
  const { mode = CUSTOMIZATION_MODES.PREVIEW, continueStep, returnUrl, shallow = false } = options;

  const params = [
    `mode=${mode}`,
    continueStep && `continueStep=${continueStep}`,
    returnUrl && `returnUrl=${returnUrl}`
  ].filter(Boolean).join('&');

  const url = `${CUSTOMIZATION_ROUTE_PREFIX}/${id}/${step}/${params}`;

  Router.push(CUSTOMIZATION_ROUTE, url, { shallow });
};

export const customizationFindStepByUrl = (steps, url) => steps.find((step) => step.url === url);
export const customizationFindStepById = (steps, id) => steps.find((step) => step.id === id);
export const customizationGetNextStep = (step) => customizationFindStepById(CUSTOMIZATION_STEPS, step.id + 1);
export const customizationGetPrevStep = (step) => customizationFindStepById(CUSTOMIZATION_STEPS, step.id - 1);

export const formatCustomization = (customization) => ({
  text: customization?.message || '',
  orientation: customization?.orientation?.toLowerCase(),
  size: customization?.size?.toLowerCase(),
  signature: customization?.signature?.content || '',
  position: customization?.signature?.position?.toLowerCase()
});

export const formatToSave = (customization) => ({
  message: customization.text,
  orientation: customization.orientation.toUpperCase(),
  size: customization.size.toUpperCase(),
  signature: {
    content: customization.signature,
    position: customization.position.toUpperCase()
  }
});

export const getAttributeToSave = (currentCustomization, initialCustomization) => {
  const attributeToSave = [];
  Object.keys(currentCustomization).forEach((attr) => {
    if (currentCustomization[attr] !== initialCustomization[attr]) {
      attributeToSave.push({ attributeName: attr, newValue: currentCustomization[attr] });
    }
  });
  const { attributeName, newValue } = attributeToSave[0];
  return { attributeName, newValue };
};

export const getIsCustomizable = (element) => element.product.item.isCustomizable;
